import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig
} from '@angular/router';

import { APP_ROUTES } from './app-routing.routes';
import { ROUTER_CONFIG_SERVICE_PROVIDER } from './router-config.service';

export const APP_ROUTING_PROVIDERS: Array<Provider | EnvironmentProviders> = [
  provideRouter(
    APP_ROUTES,
    withComponentInputBinding(),
    withEnabledBlockingInitialNavigation(),
    withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
  ),
  ROUTER_CONFIG_SERVICE_PROVIDER
];
